import _typeof from '@babel/runtime-corejs3/helpers/typeof';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';
import _URLSearchParams from '@babel/runtime-corejs3/core-js-stable/url-search-params';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import Cookies from 'js-cookie';
import _lastIndexOfInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/last-index-of';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import _parseFloat from '@babel/runtime-corejs3/core-js-stable/parse-float';
import _reduceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reduce';
import { vsprintf } from 'sprintf-js';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _someInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/some';
import parseInterval from 'math-interval-parser';
import Mustache from 'mustache';
import MessageFormat from 'messageformat';
import MakePlural from 'make-plural-compiler';
import plurals from 'cldr-core/supplemental/plurals.json';
import _sortInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/sort';

var COOKIES_LIFE_TIME = 3600;
var IS_BROWSER = typeof window !== 'undefined';

var Config = /*#__PURE__*/function () {
  function Config() {
    var _context, _context2, _context3, _context4, _context5, _context6, _context7;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var isFork = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, Config);

    this.defaultLocale = 'en';
    this.locales = {};
    this.fallbacks = {};
    this.objectNotation = false;
    this.cookieName = null;
    this.queryParameter = 'locale';
    this.unknownPhraseListener = null;
    this.processors = [];
    this.isDestroyed = false;
    this.isConstructed = false;
    this.isFork = false;
    this.forks = [];
    this.forkLinkedFields = {
      defaultLocale: true,
      locales: true,
      unknownPhraseListener: true
    };
    this.onUnknownPhrase = _bindInstanceProperty(_context = this.onUnknownPhrase).call(_context, this);
    this.setLocale = _bindInstanceProperty(_context2 = this.setLocale).call(_context2, this);
    this.getLocale = _bindInstanceProperty(_context3 = this.getLocale).call(_context3, this);
    this.getLocales = _bindInstanceProperty(_context4 = this.getLocales).call(_context4, this);
    this.getCatalog = _bindInstanceProperty(_context5 = this.getCatalog).call(_context5, this);
    this.addLocale = _bindInstanceProperty(_context6 = this.addLocale).call(_context6, this);
    this.removeLocale = _bindInstanceProperty(_context7 = this.removeLocale).call(_context7, this);
    this.isFork = isFork;
    this.configure(config);
    this.isConstructed = true;
  }
  /**
   * Change config.
   * @param config - Config options.
   * @returns Config.
   */


  _createClass(Config, [{
    key: "configure",
    value: function configure(_ref) {
      var defaultLocale = _ref.defaultLocale,
          locales = _ref.locales,
          fallbacks = _ref.fallbacks,
          objectNotation = _ref.objectNotation,
          cookieName = _ref.cookieName,
          queryParameter = _ref.queryParameter,
          unknownPhraseListener = _ref.unknownPhraseListener,
          processors = _ref.processors;
      var isConstructed = this.isConstructed,
          isFork = this.isFork,
          forkLinkedFields = this.forkLinkedFields;
      var linkedField = !isConstructed || !isFork; // setting defaultLocale

      if (typeof defaultLocale === 'string') {
        this.defaultLocale = defaultLocale;
        forkLinkedFields.defaultLocale = linkedField;
      } // read languages locales


      if (_typeof(locales) === 'object') {
        this.locales = locales;
        forkLinkedFields.locales = linkedField;
      } // read language fallback map


      if (_typeof(fallbacks) === 'object') {
        this.fallbacks = fallbacks;
      }

      if (!isFork || !isConstructed) {
        // enable object notation?
        if (typeof objectNotation === 'boolean') {
          this.objectNotation = objectNotation;
        } // sets a custom cookie name to parse locale settings from


        if (typeof cookieName === 'string') {
          this.cookieName = cookieName;
        }
      }

      if (!isFork) {
        var localeFromCookies = IS_BROWSER && Cookies.get(this.cookieName);

        if (typeof localeFromCookies === 'string') {
          this.defaultLocale = localeFromCookies;
        } // get default locale from url


        var typeofQueryParameter = _typeof(queryParameter);

        if (IS_BROWSER && typeofQueryParameter !== 'undefined') {
          var key = typeofQueryParameter === 'string' ? queryParameter : 'locale';
          var localeFromQuery = new _URLSearchParams(location.search).get(key);

          if (typeof localeFromQuery === 'string') {
            this.defaultLocale = localeFromQuery;
          }
        }
      }

      if (_Array$isArray(processors)) {
        this.processors = processors;
      }

      if (typeof unknownPhraseListener === 'function') {
        this.unknownPhraseListener = unknownPhraseListener;
        forkLinkedFields.unknownPhraseListener = linkedField;
      }

      var defaultLocaleIsLinked = forkLinkedFields.defaultLocale;
      this.setLocale(this.defaultLocale);
      forkLinkedFields.defaultLocale = defaultLocaleIsLinked;
      return this;
    }
    /**
     * Destroy instance.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.isDestroyed = true;
      this.defaultLocale = null;
      this.locales = null;
      this.fallbacks = null;
      this.objectNotation = null;
      this.cookieName = null;
      this.queryParameter = null;
      this.unknownPhraseListener = null;
      this.processors = null;
      this.forks = null;
      this.isFork = null;
      this.forkLinkedFields = null;
    }
    /**
     * Copy current config with some overrides.
     * @param config - Config with overrides.
     * @param hard - Do hard fork without linked fields.
     * @returns Forked config.
     */

  }, {
    key: "fork",
    value: function fork() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var hard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var soft = !hard;
      var forkedConfig = new Config(this, soft).configure(config);

      if (soft) {
        this.forks.push(forkedConfig);
      }

      return forkedConfig;
    }
    /**
     * Call given method for all forks.
     * @param caller - Function to call method of fork.
     * @param flagName - Flag name to check ability to call method.
     */

  }, {
    key: "callForkMethod",
    value: function callForkMethod(caller, flagName) {
      var _context8;

      this.forks = _filterInstanceProperty(_context8 = this.forks).call(_context8, function (fork) {
        if (fork.isDestroyed) {
          return false;
        }

        if (fork.forkLinkedFields[flagName]) {
          fork.isFork = false;
          caller(fork);
          fork.isFork = true;
        }

        return true;
      });
    }
    /**
     * Create translate function(s) copy, binded to another config.
     * @param fnOrFns - Translate function(s).
     * @returns Binded function(s).
     */

  }, {
    key: "bind",
    value: function bind(fnOrFns) {
      var _this = this;

      if (_Array$isArray(fnOrFns)) {
        return _mapInstanceProperty(fnOrFns).call(fnOrFns, function (fn) {
          return _bindInstanceProperty(_this).call(_this, fn);
        });
      }

      var source = fnOrFns.source;
      var fnSource = typeof source === 'function' ? source : fnOrFns;

      var bindedFn = _bindInstanceProperty(fnSource).call(fnSource, this);

      bindedFn.source = fnSource;
      return bindedFn;
    }
    /**
     * Set function to call when unknown phrase was translated.
     * @param listener - Locale change listener.
     * @returns Config.
     */

  }, {
    key: "onUnknownPhrase",
    value: function onUnknownPhrase(listener) {
      var isFork = this.isFork,
          forkLinkedFields = this.forkLinkedFields;
      var linkedField = !isFork;
      forkLinkedFields.unknownPhraseListener = linkedField;
      this.unknownPhraseListener = listener;
      this.callForkMethod(function (fork) {
        return fork.onUnknownPhrase(listener);
      }, 'unknownPhraseListener');
      return this;
    }
    /**
     * Set current locale.
     * @param locale - Locale to set.
     * @returns Config.
     */

  }, {
    key: "setLocale",
    value: function setLocale(locale) {
      var isFork = this.isFork,
          forkLinkedFields = this.forkLinkedFields,
          locales = this.locales,
          cookieName = this.cookieName;
      var linkedField = !isFork;
      var nextLocale = this.getLocale(true, locale, true);
      forkLinkedFields.defaultLocale = linkedField; // called like setLocale('en')

      if (_typeof(locales[nextLocale]) === 'object') {
        this.defaultLocale = nextLocale;

        if (IS_BROWSER && cookieName) {
          Cookies.set(cookieName, nextLocale, {
            expires: COOKIES_LIFE_TIME,
            path: '/'
          });
        }
      }

      this.callForkMethod(function (fork) {
        return fork.setLocale(locale);
      }, 'defaultLocale');
      return this;
    }
    /**
     * Get current locale.
     * @param checkFallback - Flag to use fallback or not.
     * @param localeToCheck - Locale to handle.
     * @param strict - Should fall back to default locale or not.
     * @returns Current locale.
     */

  }, {
    key: "getLocale",
    value: function getLocale(checkFallback, localeToCheck) {
      var strict = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (checkFallback === true) {
        var defaultLocale = this.defaultLocale,
            locales = this.locales,
            fallbacks = this.fallbacks;
        var locale = localeToCheck;

        if (typeof locale !== 'string') {
          locale = defaultLocale;
        }

        if (_typeof(locales[locale]) !== 'object' && typeof fallbacks[locale] === 'string') {
          locale = fallbacks[locale];
        }

        if (!strict && _typeof(locales[locale]) !== 'object') {
          locale = defaultLocale;
        }

        return locale;
      }

      return this.defaultLocale;
    }
    /**
     * Get available locales.
     * @returns Available locales.
     */

  }, {
    key: "getLocales",
    value: function getLocales() {
      var _context9;

      var locales = this.locales;
      return _filterInstanceProperty(_context9 = _Object$keys(locales)).call(_context9, function (_) {
        return _typeof(locales[_]) === 'object';
      });
    }
    /**
     * Get whole catalog optionally based on given locale.
     * @param locale - Locale to get sub-catalog.
     * @returns Catalog.
     */

  }, {
    key: "getCatalog",
    value: function getCatalog(locale) {
      var locales = this.locales;

      if (typeof locale === 'undefined') {
        return locales;
      }

      var targetLocale = this.getLocale(true, locale, true);
      var catalog = locales[targetLocale];

      if (_typeof(catalog) === 'object') {
        return catalog;
      }

      return null;
    }
    /**
     * Add new translations.
     * @param locale - Locale to add.
     * @param catalog - Catalog for localte to add.
     * @returns Config.
     */

  }, {
    key: "addLocale",
    value: function addLocale(locale, catalog) {
      var isFork = this.isFork,
          forkLinkedFields = this.forkLinkedFields,
          locales = this.locales;
      var linkedField = !isFork;
      forkLinkedFields.locales = linkedField;
      locales[locale] = catalog; // No need `callForkMethod` due to `locales` is object.

      return this;
    }
    /**
     * Remove translations.
     * @param locale - Locale to remove.
     * @returns Config.
     */

  }, {
    key: "removeLocale",
    value: function removeLocale(locale) {
      var isFork = this.isFork,
          forkLinkedFields = this.forkLinkedFields,
          locales = this.locales;
      var linkedField = !isFork;
      forkLinkedFields.locales = linkedField;
      delete locales[locale]; // No need `callForkMethod` due to `locales` is object.

      return this;
    }
  }]);

  return Config;
}();

var SEPARATOR = '.';
var DEFAULT_VALUE_SEPARATOR = ':';

var NOOP = function NOOP() {
  return null;
};
/**
 * Check data type.
 * @param maybeStrings - Maybe array of strings.
 * @returns Given data is array of strings.
 */


function isStringsArray(maybeStrings) {
  return _Array$isArray(maybeStrings);
}
/**
 * Handling of template literals.
 * @param text - Text or text parts.
 * @returns Processed text.
 */

function preProcess(text) {
  if (isStringsArray(text)) {
    return text.join(text.hasOwnProperty('raw') ? '%s' : '');
  }

  return text;
}
/**
 * Handling of templates.
 * @param text - Text to process.
 * @param namedValues - Named values for mustache.
 * @param values - List of values for vsprintf.
 * @param count - Plural param.
 * @returns Processed text.
 */

function postProcess(config, text, namedValues, values, count) {
  var _context;

  var processedText = _reduceInstanceProperty(_context = config.processors).call(_context, function (text, processor) {
    return processor(text, namedValues, values, count);
  }, text); // replace the counter


  if (typeof count === 'number') {
    processedText = vsprintf(processedText, [count]);
  } // if we have extra arguments with values to get replaced,
  // an additional substition injects those strings afterwards


  if (/%/.test(processedText) && values.length) {
    processedText = vsprintf(processedText, values);
  }

  return String(processedText);
}
/**
 * Get singular from plurals object.
 * @param plurals - Plurals object to get sigular form.
 * @returns Singular.
 */

function getSingularFromPlurals(plurals) {
  if (typeof plurals.one !== 'undefined') {
    return plurals.one;
  } // in case there is no 'one' but an 'other' rule


  if (typeof plurals.other !== 'undefined') {
    return plurals.other;
  }

  return null;
}
/**
 * Parse float from string, if `num` is `string`.
 * @param num - Number or string to handle.
 * @returns Maybe number and number is or not.
 */

function tryParseFloat(num) {
  if (typeof num === 'number') {
    return [num, true];
  }

  var maybeNumber = _parseFloat(num);

  var isNumberLike = num === String(maybeNumber);
  return [maybeNumber, isNumberLike];
}
/**
 * Core translate function.
 * @param config - Config object.
 * @param locale - Target locale.
 * @param singular - Singular form.
 * @param plural - Plural form.
 * @returns Translation.
 */

function translate(config, locale, singular, plural) {
  var objectNotation = config.objectNotation;
  var targetLocale = config.getLocale(true, locale);
  var targetSingular = singular;
  var targetPlural = plural;
  var defaultSingular = targetSingular;
  var defaultPlural = targetPlural;

  if (objectNotation) {
    var indexOfColon = _indexOfInstanceProperty(targetSingular).call(targetSingular, DEFAULT_VALUE_SEPARATOR); // We compare against 0 instead of -1 because we don't really expect the string to start with ':'.


    if (indexOfColon > 0) {
      defaultSingular = targetSingular.substring(indexOfColon + 1);
      targetSingular = targetSingular.substring(0, indexOfColon);
    }

    if (targetPlural && typeof targetPlural !== 'number') {
      indexOfColon = _indexOfInstanceProperty(targetPlural).call(targetPlural, DEFAULT_VALUE_SEPARATOR);

      if (indexOfColon > 0) {
        defaultPlural = targetPlural.substring(indexOfColon + 1);
        targetPlural = targetPlural.substring(0, indexOfColon);
      }
    }
  }

  var accessor = localeAccessor(config, targetLocale, targetSingular, true);
  var mutator = localeMutator(config, targetLocale, targetSingular, false);
  var accessFirstTry = accessor();

  if (targetPlural && (!accessFirstTry || _typeof(accessFirstTry) !== 'object')) {
    mutator({
      one: defaultSingular || targetSingular,
      other: defaultPlural || targetPlural
    });
  }

  if (!accessor()) {
    mutator(defaultSingular || targetSingular);
  }

  return accessor();
}
/**
 * Get singluar or plurls object.
 * @param result - Singluar or plurls object.
 * @returns Valid result.
 */

function getValidResult(result) {
  return typeof result === 'string' || result !== null && _typeof(result) === 'object' && (result.hasOwnProperty('one') || result.hasOwnProperty('other')) ? result : null;
}
/**
 * Allows delayed access to translations nested inside objects.
 * @param config - Config object.
 * @param locale - The locale to use.
 * @param singular - The singular term to look up.
 * @param allowDelayedTraversal - Is delayed traversal of the tree allowed?
 * This parameter is used internally. It allows to signal the accessor that
 * a translation was not found in the initial lookup and that an invocation
 * of the accessor may trigger another traversal of the tree.
 * @returns A function that, when invoked, returns the current value stored
 * in the object at the requested location.
 */


function localeAccessor(config, locale, singular) {
  var allowDelayedTraversal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var locales = config.locales,
      objectNotation = config.objectNotation; // Bail out on non-existent locales to defend against internal errors.

  if (_typeof(locales[locale]) !== 'object') {
    return NOOP;
  } // Handle object lookup notation


  var indexOfSeparator = objectNotation && _lastIndexOfInstanceProperty(singular).call(singular, SEPARATOR);

  if (objectNotation && indexOfSeparator > 0 && indexOfSeparator < singular.length - 1) {
    var _context2;

    // The accessor we're trying to find and which we want to return.
    var accessor; // Do we need to re-traverse the tree upon invocation of the accessor?

    var reTraverse = false; // Split the provided term and run the callback for each subterm.

    _reduceInstanceProperty(_context2 = singular.split(SEPARATOR)).call(_context2, function (object, index) {
      // Make the accessor return null.
      accessor = NOOP; // If our current target object (in the locale tree) doesn't exist or
      // it doesn't have the next subterm as a member...

      if (object === null || !object.hasOwnProperty(index)) {
        // ...remember that we need retraversal (because we didn't find our target).
        reTraverse = allowDelayedTraversal; // Return null to avoid deeper iterations.

        return null;
      } // We can traverse deeper, so we generate an accessor for this current level.


      accessor = function accessor() {
        return getValidResult(object[index]);
      }; // Return a reference to the next deeper level in the locale tree.


      return object[index];
    }, locales[locale]); // Return the requested accessor.


    return function () {
      return (// If we need to re-traverse (because we didn't find our target term)
        // traverse again and return the new result (but don't allow further iterations)
        // or return the previously found accessor if it was already valid.
        reTraverse ? localeAccessor(config, locale, singular, false)() : accessor()
      );
    };
  } // No object notation, just return an accessor that performs array lookup.


  return function () {
    return getValidResult(locales[locale][singular]);
  };
}
/**
 * Allows delayed mutation of a translation nested inside objects.
 * @description Construction of the mutator will attempt to locate the requested term
 * inside the object, but if part of the branch does not exist yet, it will not be
 * created until the mutator is actually invoked. At that point, re-traversal of the
 * tree is performed and missing parts along the branch will be created.
 * @param config - Config object.
 * @param locale - The locale to use.
 * @param singular - The singular term to look up.
 * @param allowBranching - Is the mutator allowed to create previously
 * non-existent branches along the requested locale path?
 * @returns A function that takes one argument. When the function is
 * invoked, the targeted translation term will be set to the given value inside the locale table.
 */


function localeMutator(config, locale, singular) {
  var allowBranching = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var locales = config.locales,
      objectNotation = config.objectNotation,
      unknownPhraseListener = config.unknownPhraseListener;
  var withUnknownPhraseListener = typeof unknownPhraseListener === 'function'; // Bail out on non-existent locales to defend against internal errors.

  if (_typeof(locales[locale]) !== 'object') {
    return NOOP;
  } // Handle object lookup notation


  var indexOfSeparator = objectNotation && _lastIndexOfInstanceProperty(singular).call(singular, SEPARATOR);

  if (objectNotation && indexOfSeparator > 0 && indexOfSeparator < singular.length - 1) {
    var _context3;

    // This will become the function we want to return.
    var accessor; // Fix object path.

    var fixObject = function fixObject() {
      return {};
    }; // Are we going to need to re-traverse the tree when the mutator is invoked?


    var reTraverse = false; // Split the provided term and run the callback for each subterm.

    _reduceInstanceProperty(_context3 = singular.split(SEPARATOR)).call(_context3, function (prevObject, index) {
      var object = prevObject; // Make the mutator do nothing.

      accessor = NOOP; // If our current target object (in the locale tree) doesn't exist or
      // it doesn't have the next subterm as a member...

      if (object === null || !object.hasOwnProperty(index)) {
        // ...check if we're allowed to create new branches.
        if (allowBranching) {
          // Fix `object` if `object` is not Object.
          if (object === null || _typeof(object) !== 'object') {
            object = fixObject();
          } // If we are allowed to, create a new object along the path.


          object[index] = {};
        } else {
          // If we aren't allowed, remember that we need to re-traverse later on and...
          reTraverse = true; // ...return null to make the next iteration bail our early on.

          return null;
        }
      } // Generate a mutator for the current level.


      accessor = withUnknownPhraseListener ? function (value) {
        unknownPhraseListener(locale, singular, value);
        return object[index] = value;
      } : function (value) {
        return object[index] = value;
      }; // Generate a fixer for the current level.

      fixObject = function fixObject() {
        return object[index] = {};
      }; // Return a reference to the next deeper level in the locale tree.


      return object[index];
    }, locales[locale]); // Return the final mutator.


    return function (value) {
      return (// If we need to re-traverse the tree
        // invoke the search again, but allow branching this time (because here the mutator is being invoked)
        // otherwise, just change the value directly.
        reTraverse ? localeMutator(config, locale, singular, true)(value) : accessor(value)
      );
    };
  } // No object notation, just return a mutator that performs array lookup and changes the value.


  return withUnknownPhraseListener ? function (value) {
    unknownPhraseListener(locale, singular, value);
    return locales[locale][singular] = value;
  } : function (value) {
    return locales[locale][singular] = value;
  };
}

var globalConfig = new Config();
function getConfigFromContext(context) {
  return context instanceof Config ? context : globalConfig;
}
function getTranslateFromConfig(config, phraseOrParams) {
  var locale = config.defaultLocale;
  var phrase; // called like __({ phrase: 'Hello', locale: 'en' })

  if (_typeof(phraseOrParams) === 'object' && !isStringsArray(phraseOrParams)) {
    phrase = phraseOrParams.phrase;

    if (typeof phraseOrParams.locale === 'string') {
      locale = phraseOrParams.locale;
    } // called like __('Hello') or __`Hello`

  } else {
    phrase = preProcess(phraseOrParams);
  }

  return [// get translated message with locale
  translate(config, locale, phrase), locale];
}

/**
 * Splits and parses a phrase for mathematical interval expressions.
 * @param phrase - Phrase to parse.
 * @param count - Target count.
 * @returns Phrase.
 */

function parsePluralInterval(phrase, count) {
  var phrases = phrase.split(/\|/);
  var returnPhrase = phrase; // some() breaks on 1st true

  _someInstanceProperty(phrases).call(phrases, function (p) {
    var _p$match = p.match(/^\s*([()\[\]\d,]+)?\s*(.*)$/),
        _p$match2 = _slicedToArray(_p$match, 3),
        m1 = _p$match2[1],
        m2 = _p$match2[2]; // not the same as in combined condition


    if (m1) {
      if (matchInterval(count, m1)) {
        returnPhrase = m2;
        return true;
      }
    } else {
      returnPhrase = p;
    }

    return false;
  });

  return returnPhrase;
}
/**
 * test a number to match mathematical interval expressions
 * [0,2] - 0 to 2 (including, matches: 0, 1, 2)
 * ]0,3[ - 0 to 3 (excluding, matches: 1, 2)
 * [1]   - 1 (matches: 1)
 * [20,] - all numbers ≥20 (matches: 20, 21, 22, ...)
 * [,20] - all numbers ≤20 (matches: 20, 21, 22, ...)
 * @param num - Number to match.
 * @param interval - Interval query.
 * @returns Match or not.
 */


function matchInterval(num, interval) {
  var parsedInterval = parseInterval(interval);

  if (parsedInterval && typeof num === 'number') {
    var _parsedInterval$from = parsedInterval.from,
        fromIncluded = _parsedInterval$from.included,
        fromValue = _parsedInterval$from.value,
        _parsedInterval$to = parsedInterval.to,
        toIncluded = _parsedInterval$to.included,
        toValue = _parsedInterval$to.value;

    if (fromValue === num) {
      return fromIncluded;
    }

    if (toValue === num) {
      return toIncluded;
    }

    return Math.min(fromValue, num) === fromValue && Math.max(toValue, num) === toValue;
  }

  return false;
}
/**
 * Handle plural interval templates.
 * @param text - Input text.
 * @param namedValues - Named values.
 * @param values - Listed values.
 * @param count - Count.
 */


function pluralIntervalProcessor(text, _, __, count) {
  if (/\|/.test(text) && typeof count === 'number') {
    return parsePluralInterval(text, count);
  }

  return text;
}
/**
 * Handle mustache templates.
 * @param text - Input text.
 * @param namedValues - Named values.
 * @param values - Listed values.
 * @param count - Count.
 */

function mustacheProcessor(text, namedValues) {
  if (/\{\{.*\}\}/.test(text)) {
    return Mustache.render(text, namedValues);
  }

  return text;
}

/**
 * Translates a single phrase and adds it to locales if unknown.
 * @param phraseOrParams - Phrase to translate or params.
 * @param values - Values to print.
 * @returns Translated parsed and substituted string.
 */

function __(phraseOrParams) {
  var config = getConfigFromContext(this); // get translated message with locale

  var _getTranslateFromConf = getTranslateFromConfig(config, phraseOrParams),
      _getTranslateFromConf2 = _slicedToArray(_getTranslateFromConf, 1),
      translated = _getTranslateFromConf2[0];

  var namedValues; // postprocess to get compatible to plurals

  if (_typeof(translated) === 'object') {
    translated = getSingularFromPlurals(translated);
  } // Accept an object with named values as the last parameter


  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (_typeof(values[values.length - 1]) === 'object') {
    namedValues = values.pop();
  }

  return postProcess(config, translated, namedValues, values);
}

var messageFormatInstanceForLocale = {};
/**
 * Supports the advanced MessageFormat as provided by excellent messageformat module.
 * You should definetly head over to messageformat.github.io for a guide to MessageFormat.
 * `i18n-for-browser` takes care of `new MessageFormat('en').compile(msg);`
 * with the current msg loaded from it's json files and cache that complied fn in memory.
 * So in short you might use it similar to `__()` plus extra object to accomblish MessageFormat's formating.
 * @param phraseOrParams - Phrase to translate or params.
 * @param values - Values to print.
 * @returns Translate.
 */

function __mf(phraseOrParams) {
  var config = getConfigFromContext(this); // get translated message with locale

  var _getTranslateFromConf = getTranslateFromConfig(config, phraseOrParams),
      _getTranslateFromConf2 = _slicedToArray(_getTranslateFromConf, 2),
      translated = _getTranslateFromConf2[0],
      locale = _getTranslateFromConf2[1];

  var namedValues;
  var mf;
  var f; // postprocess to get compatible to plurals

  if (_typeof(translated) === 'object') {
    translated = getSingularFromPlurals(translated);
  } // now head over to MessageFormat
  // and try to cache instance


  if (messageFormatInstanceForLocale[locale]) {
    mf = messageFormatInstanceForLocale[locale];
  } else {
    mf = new MessageFormat(locale);
    mf.compiledFunctions = {};
    messageFormatInstanceForLocale[locale] = mf;
  }

  var cacheKey = String(translated); // let's try to cache that function

  if (mf.compiledFunctions[cacheKey]) {
    f = mf.compiledFunctions[cacheKey];
  } else {
    f = mf.compile(translated);
    mf.compiledFunctions[cacheKey] = f;
  } // Accept an object with named values as the last parameter


  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (_typeof(values[values.length - 1]) === 'object') {
    namedValues = values.pop();
  }

  return postProcess(config, f(namedValues), namedValues, values);
}

var pluralsInstanceForLocale = {};
/**
 * Plurals translation of a single phrase.
 * Singular and plural forms will get added to locales if unknown.
 * @param singularOrParams - Singular form to translate or params.
 * @param pluralOrCount - Plural form to translate or target count.
 * @param count - Target count.
 * @param values - Values to print.
 * @returns Translated parsed and substituted string based on `count` parameter.
 */

function __n(singularOrParams, pluralOrCount, count) {
  var config = getConfigFromContext(this);
  var defaultLocale = config.defaultLocale;
  var locale = defaultLocale;
  var singular;
  var plural;
  var countNumber;
  var translated;
  var namedValues; // some template engines pass all values as strings -> so we try to convert them to numbers

  var _tryParseFloat = tryParseFloat(pluralOrCount),
      _tryParseFloat2 = _slicedToArray(_tryParseFloat, 2),
      pluralOrCountNumber = _tryParseFloat2[0],
      pluralOrCountIsNumber = _tryParseFloat2[1]; // called like __n({ singular: '%s cat', plural: '%s cats', locale: 'en' }, 3)


  for (var _len = arguments.length, values = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    values[_key - 3] = arguments[_key];
  }

  if (_typeof(singularOrParams) === 'object' && !isStringsArray(singularOrParams)) {
    values.unshift(count);
    singular = singularOrParams.singular;

    if (typeof singularOrParams.locale === 'string') {
      locale = singularOrParams.locale;
    }

    if (typeof singularOrParams.plural === 'string') {
      plural = singularOrParams.plural;
    }

    if (pluralOrCountIsNumber) {
      countNumber = pluralOrCountNumber; // called like __n({singular: '%s cat', plural: '%s cats', locale: 'en', count: 3})
    } else {
      values.unshift(pluralOrCount);

      var _tryParseFloat3 = tryParseFloat(singularOrParams.count),
          _tryParseFloat4 = _slicedToArray(_tryParseFloat3, 2),
          maybeNumber = _tryParseFloat4[0],
          isNumber = _tryParseFloat4[1];

      if (isNumber) {
        countNumber = maybeNumber;
      }
    }
  } else {
    singular = preProcess(singularOrParams); // called like __n('cat', 3) or __n`cat ${3}`

    if (pluralOrCountIsNumber) {
      values.unshift(count); // we add same string as default
      // which efectivly copies the key to the plural.value
      // this is for initialization of new empty translations

      plural = singular;
      countNumber = pluralOrCountNumber;
    } else {
      var _tryParseFloat5 = tryParseFloat(count),
          _tryParseFloat6 = _slicedToArray(_tryParseFloat5, 2),
          _maybeNumber = _tryParseFloat6[0],
          _isNumber = _tryParseFloat6[1]; // called like __n('%s cat', '%s cats', 3)


      if (_isNumber && typeof pluralOrCount === 'string') {
        plural = pluralOrCount;
        countNumber = _maybeNumber;
      }
    }
  }

  translated = translate(config, locale, singular, plural); // find the correct plural rule for given locale

  if (_typeof(translated) === 'object') {
    var p; // create a new Plural for locale
    // and try to cache instance

    if (pluralsInstanceForLocale[locale]) {
      p = pluralsInstanceForLocale[locale];
    } else {
      MakePlural.load(plurals);
      p = new MakePlural(locale).compile();
      pluralsInstanceForLocale[locale] = p;
    } // fallback to 'other' on case of missing translations


    translated = translated[p(countNumber)] || translated.other;
  } // Accept an object with named values as the last parameter


  if (_typeof(values[values.length - 1]) === 'object') {
    namedValues = values.pop();
  }

  return postProcess(config, translated, namedValues, values, countNumber);
}

/**
 * Get map of translations for a given phrase in each language.
 * @param method - Source translation method to use.
 * @param args - Method arguments.
 * @returns Map of translations.
 */

function __m(method) {
  var _context, _context2;

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var config = getConfigFromContext(this).fork();

  var translations = _reduceInstanceProperty(_context = _sortInstanceProperty(_context2 = config.getLocales()).call(_context2)).call(_context, function (translations, locale) {
    config.setLocale(locale);
    translations[locale] = method.apply(config, args);
    return translations;
  }, {});

  config.destroy();
  return translations;
}

export default globalConfig;
export { __, __m, __mf, __n, mustacheProcessor, pluralIntervalProcessor };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguZXMuanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=
